var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41107 6.91083C4.73651 6.58539 5.26414 6.58539 5.58958 6.91083L10.0003 11.3216L14.4111 6.91083C14.7365 6.58539 15.2641 6.58539 15.5896 6.91083C15.915 7.23626 15.915 7.7639 15.5896 8.08934L10.5896 13.0893C10.2641 13.4148 9.73651 13.4148 9.41107 13.0893L4.41107 8.08934C4.08563 7.7639 4.08563 7.23626 4.41107 6.91083Z",
    fill: "#7C828D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIcon);
export default __webpack_public_path__ + "static/media/dropdownIcon.e83d5bd15f51951b799178b2a353d7ea.svg";
export { ForwardRef as ReactComponent };